import React, { useEffect, useState } from 'react';
import { DeviceTaskType } from 'lavva.exalushome/build/js/Services/Devices/IDevice';
import { DeviceControlFeature } from 'lavva.exalushome/build/js/Services/Devices/IDeviceTask';
import { LightRGBW } from 'lavva.exalushome/build/js/Services/Devices/Tasks/Tasks';
import { RgbaColor } from '@uiw/color-convert';
import { RgbwChannelSettings } from '../../../../../../../modules/action-create/channel-settings/rgbw';
import { DeviceTaskParams, RGBWStateTask } from '../../../../../../../types/actions';
import { rgbaToRgbString } from '../../../../../../../utils/helpers';
import { useExalusCreateActionContext } from '../../../context';
import { useTaskEdit } from '../../../hooks/use-task-edit';

export const RGBWSettings: React.FC = () => {
  const { channels } = useExalusCreateActionContext();
  const { task, finalizeDeviceTaskSubmit } = useTaskEdit();
  const [rgbValue, setRgbValue] = useState<string>('');
  const [brightness, setBrightness] = useState<number>(100);
  const [wValue, setWValue] = useState<number>(0);

  useEffect(() => {
    const R = 49;
    const G = 255;
    const B = 67;
    setRgbValue(`${R.toString()},${G.toString()},${B.toString()}`);
  }, []);

  useEffect(() => {
    if (task) {
      const params = (task.taskParams as DeviceTaskParams).state as RGBWStateTask;
      setRgbValue(`${params.R.toString()},${params.G.toString()},${params.B.toString()}`);
      setBrightness(params.Brightness);
      setWValue(params.W || 0);
    }
  }, [task]);

  const handleChange = (value: number) => setBrightness(value);

  const handleChangeW = (value: number) => setWValue(value);

  const handleColorPicked = (rgba: RgbaColor) => {
    const rgb = rgbaToRgbString(rgba);

    setRgbValue(rgb);
  };

  const handleBrightness = (value: number) => setBrightness(value);

  const handleWValue = (value: number) => setWValue(value);

  const handleSubmit = () => {
    for (let i = 0; i < channels.length; i++) {
      const task = new LightRGBW();
      task.DeviceGuid = channels[i].GetDevice().Guid;
      task.Channel = channels[i].Number;
      task.TaskType = DeviceTaskType.LightRGBW;
      task.FeatureType = DeviceControlFeature.LightRGBW;
      const values = rgbValue.split(',');
      const R = parseInt(values[0]);
      const G = parseInt(values[1]);
      const B = parseInt(values[2]);
      const W = wValue;
      task.Data.R = R;
      task.Data.G = G;
      task.Data.B = B;

      if (W) task.Data.W = W;
      task.Data.Brightness = brightness;

      finalizeDeviceTaskSubmit(
        task,
        channels[i],
        { R, G, B, W, Brightness: brightness } as RGBWStateTask,
        i === channels.length - 1,
      );
    }
  };

  return (
    <RgbwChannelSettings
      rgbValue={rgbValue}
      handleColorPicked={handleColorPicked}
      handleSubmit={handleSubmit}
      wValue={wValue}
      brightness={brightness}
      handleChangeW={handleChangeW}
      handleWValue={handleWValue}
      handleChangeBrightness={handleChange}
      handleBrightness={handleBrightness}
    />
  );
};
